import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";
import { isTicketPurchaseItem } from "@app/types/napi-v2-purchase-types";
import type { NapiV2TicketItem } from "@app/types/napi-v2-tickets-types";

import { getPurchaseTrip } from "./get-purchase-trip";
import { isRoundtrip } from "../udm/is-roundtrip";

type PurchaseTicketsPerLeg = {
  outbound_tickets: NapiV2TicketItem[];
  return_tickets: NapiV2TicketItem[] | null;
};

export function getPurchaseTicketsPerLeg(
  purchase: NapiV2Purchase
): PurchaseTicketsPerLeg {
  const tickets = purchase.items.filter(isTicketPurchaseItem);
  const trip = getPurchaseTrip(purchase);

  return {
    outbound_tickets: getSegmentsTickets(
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      trip.trip_legs[0].segment_ids,
      tickets
    ),
    return_tickets: isRoundtrip(trip)
      ? // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        getSegmentsTickets(trip.trip_legs[1].segment_ids, tickets)
      : null
  };
}

function getSegmentsTickets(
  segment_ids: string[],
  tickets: NapiV2TicketItem[]
): NapiV2TicketItem[] {
  const segments_tickets_set: Set<NapiV2TicketItem> = new Set();

  for (const ticket of tickets) {
    for (const ticket_segment of ticket.trip.segment_ids) {
      if (segment_ids.includes(ticket_segment)) {
        segments_tickets_set.add(ticket);
      }
    }
  }

  return Array.from(segments_tickets_set);
}
